export enum ErrorCodes {
  BAD_REQUEST = 400,
  USER_NOT_FOUND = 401,
  TOKEN_NOT_FOUND = 401,
  ROLE_NOT_FOUND = 403,
  UNAUTHORIZED = 403,
  NOT_FOUND = 404,
  SERVER_ERROR = 500,
}
